var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Light / General /  External link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.3335 5.00065H5.00016C4.07969 5.00065 3.3335 5.74684 3.3335 6.66732V15.0007C3.3335 15.9211 4.07969 16.6673 5.00016 16.6673H13.3335C14.254 16.6673 15.0002 15.9211 15.0002 15.0007V11.6673M11.6668 3.33398H16.6668M16.6668 3.33398V8.33398M16.6668 3.33398L8.3335 11.6673",
    stroke: "#797A7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchDisable);
export default __webpack_public_path__ + "static/media/launch-disable.6471c2b94cf4294d4571fbfd8c4b777e.svg";
export { ForwardRef as ReactComponent };